<script>
  import { onMount } from "svelte";
  import wrappedFetch from "../wrappedFetch.js";

  let hasPermission = false;  // if user ends with .000
  let hasUser = false;        // if loggedUser exists
  let username = "";
  let message = "";

const AdminUsers = async () => {
  console.log("Checking user permission...");
  try {
    const response  = await wrappedFetch(`/user/GetUserPermission`, { method: "post" });
    if (!response.ok) {
        window.location.href = "/"; // redirect immediately on 401 or other errors
        return;
      }
      const res = await response.json();
      
      hasPermission = res.allowed;
      hasUser = res.hasUser;
      // Redirect if user is not allowed or not logged in
      if (!hasUser || !hasPermission) {
        window.location.href = "/";
      }
    } catch (err) {
      console.error("Error fetching permissions:", err);
      window.location.href = "/"; // redirect on fetch error
    }
};

  const sendPushNotification = async () => {
    if (!username.trim()) return; // optional: prevent empty messages

    try {
      await wrappedFetch(`/user/SendPushNotification`, {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, message })
      });

      alert("Push notification sent!");
      username = ""; // clear textbox
    } catch (err) {
      console.error("Error sending push notification:", err);
    }
  };

  const sendAppPushNotification = async () => {
    if (!username.trim()) return; // optional: prevent empty messages

    try {
      await wrappedFetch(`/user/SendAppPushNotification`, {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, message })
      });

      alert("Push App notification sent!");
      username = ""; // clear textbox
    } catch (err) {
      console.error("Error sending push App notification:", err);
    }
  };
  onMount(() => {
    AdminUsers();
  });



</script>


<div class="container" style="padding:5rem;">
  {#if hasUser && hasPermission}
  <input
      type="text"
      placeholder="Enter username"
      bind:value={username}
      class="input"
      style="margin-bottom: 1rem;"
    /><input
      type="text"
      placeholder="Enter Message to send"
      bind:value={message}
      class="input"
      style="margin-bottom: 1rem;"
    />
    <a href="#" class="button is-primary" on:click|preventDefault={sendPushNotification}>Send Web push notification </a>
    
    <a href="#" class="button is-info" on:click|preventDefault={sendAppPushNotification}>Send App push notification </a>
  {/if}
</div>
